<template>
  <footer>
    <div class="foot-container">
        <div class="contact-top">
            <div class="across">
            <div class="col-firt">
                <dl>
                    <dt class="web"><router-link :to="{path: '/Home'}">平台入口</router-link></dt>
                    <dt class="move" @click="flags(flag)">平台入口 <span :class="flag==true?'up':'down'">+</span> </dt>
                    <div class="web">
                    <dd><a @click="open">大数据平台入口</a></dd>
                    <dd> <a @click="opennew">物联服务商接入系统</a> </dd>
                    <dd v-if="prod === 'hp'|| prod === 'hpnw'"> <a @click="opennew2">建筑管理单位备案系统</a> </dd>
                    <dd v-else> <a @click="opennew2">建筑管理单位履责系统</a> </dd>
                    <dd> <a @click="opennew3">维保单位备案系统</a> </dd>
                    </div>
                    <div class="move" v-if="flag==true">
                    <dd><a @click="open">大数据平台入口</a></dd>
                    <dd> <a @click="opennew">物联服务商接入系统</a> </dd>
                    <dd v-if="prod === 'hp'|| prod === 'hpnw'"> <a @click="opennew2">建筑管理单位备案系统</a> </dd>
                    <dd v-else> <a @click="opennew2">建筑管理单位履责系统</a> </dd>
                    <dd> <a @click="opennew3">维保单位备案系统</a> </dd>
                    </div>
                </dl>
            </div>
            <div class="col-firt">
                <dl>
                    <dt><router-link :to="{path: '/notice'}">最新公告</router-link></dt>
                </dl>
                </div>
            <div class="col-firt">
                <dl>
                    <dt class="web"><router-link :to="{path: '/serve'}">常用服务</router-link></dt>
                    <dt class="move" @click="flagss(fla)">常用服务 <span  :class="fla==true?'up':'down'">+</span> </dt>
                    <div class="web">
                    <dd class="lh"> <a target="_blank" href="http://www.cccf.com.cn/net/qzxrzxxgb.jsp">中国消防产品质量</a> </dd>
                    <dd class="lh"> <a target="_blank" href="http://www.cccf.com.cn/net/qzxrzxxgb.jsp">信息查询系统</a> </dd>
                    <dd class="ll"> <a onClick="window.open('https://doc-v1-intro.119.net')">消防物联接入说明</a> </dd>
                    </div>
                    <div class="move" v-if="fla==true">
                    <dd class="lh"> <a href="http://www.cccf.com.cn/net/qzxrzxxgb.jsp">中国消防产品质量</a> </dd>
                    <dd class="lh"> <a href="http://www.cccf.com.cn/net/qzxrzxxgb.jsp">信息查询系统</a> </dd>
                    <dd class="ll"> <a onClick="window.open('https://doc-v1-intro.119.net')">消防物联接入说明</a> </dd>
                    </div>
                </dl>
            </div>
            <div class="col-firt">
                <dl>
                    <dt><router-link :to="{path: '/facilitator'}">已接入服务商</router-link></dt>
                </dl>
            </div>
            </div>
             <div class="right">
                <dl>
                    <!-- <dt><router-link to="build">已接入建筑</router-link></dt>
                    <dt><router-link to="company">已接入重点单位</router-link></dt>
                    <dt><router-link to="manage">建筑管理单位</router-link></dt>
                    <dt><router-link to="maintenance">维保单位</router-link></dt>
                    <dt><router-link to="firehouse">微型消防站</router-link></dt> -->
                    <dt><router-link :to="{path: '/build'}">已接入建筑</router-link></dt>
                    <dt><router-link :to="{path: '/company'}">已接入重点单位</router-link></dt>
                    <dt><router-link :to="{path: '/manage'}">建筑管理单位</router-link></dt>
                    <dt><router-link :to="{path: '/maintenance'}">维保单位</router-link></dt>
                    <dt><router-link :to="{path: '/firehouse'}">微型消防站</router-link></dt>
                    <dt class="move">关注我们 <img class="wechat" src="../../assets/wechat.png" alt=""> </dt>
                </dl>
            </div>
             <div>
                <!-- <dl class="wx">
                    <dt class="center"><img src="../../assets/images/er.png" alt=""></dt>
                    <dd class="center">打开微信扫一扫</dd>
                    <dd class="center">消防安全靠大家</dd>
                    <dd class="center">随手提交身边安全隐患</dd>
                </dl> -->
                <dl>
                    <dt><router-link :to="{path: '/build'}">建筑管理单位</router-link></dt>
                    <dt><router-link :to="{path: '/manage'}">维保单位</router-link></dt>
                    <dt><router-link :to="{path: '/firehouse'}">微型消防站</router-link></dt>
                    <!-- <dt><router-link to="build">建筑管理单位</router-link></dt>
                    <dt><router-link to="manage">维保单位</router-link></dt>
                    <dt><router-link to="firehouse">微型消防站</router-link></dt> -->
                </dl>
            </div>
        </div>
        <div class="contact-bot">
            <div class="left">
                <p>{{ title }} | <span @click="openClickNum()">沪ICP备19004601号-1</span> | Copyright©2019 | <span @click="openClick()">技术支持：腾御科技</span> </p>
            </div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      path: '',
      flag: '',
      fla: '',
      url: '',
      title: '',
      prod: process.env.ENV_SERVER
    }
  },
  created () {
    if (this.prod === 'ja') {
      this.url = 'https://ja.119.net/manage'
      this.title = '上海市静安区消防支队'
      localStorage.setItem('text', this.text)
    } else if (this.prod === 'hp' || this.prod === 'hpnw') {
      this.title = '上海市黄浦区消防支队'
      this.url = 'https://hp.119.net/manage'
      localStorage.setItem('text', this.text)
    } else if (this.prod === 'sh') {
      // this.title = '上海市消防总队'
      this.title = ''
      this.url = 'https://sh.119.net/manage'
      localStorage.setItem('text', this.text)
    } else {
      this.text = '上海'
      // this.title = '上海市消防总队'
      this.title = ''
      this.url = 'https://sh.119.net/manage'
      localStorage.setItem('text', this.text)
    }
  },
  mounted () {
    this.path = this.$route.path
  },
  methods: {
    opennew () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else {
        window.open(process.env.BASE_AGENTCLIENT)
      }
    },
    opennew2 () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else {
        window.open(process.env.BASE_AGENTCLIENT2)
      }
    },
    opennew3 () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else {
        window.open(process.env.BASE_AGENTCLIENT3)
      }
    },
    open () {
      window.open(this.url)
    },
    openClick () {
      window.open('https://www.119.net')
    },
    openClickNum () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    goto (page, selectId) {
      var path = page
      var path2 = this.path
      localStorage.setItem('toId', selectId)
      this.$router.push({path: '/' + path})
      if ('/' + path == path2) {
        this.getlocal()
      }
    },
    getlocal () {
      let selectId = localStorage.getItem('toId')
      let toElement = document.getElementById(selectId)
      if (selectId) {
        toElement.scrollIntoView()
      }
      localStorage.setItem('toId', '')
    },
    flags (flag) {
      if (flag == false) {
        this.flag = true
      } else {
        this.flag = false
      }
      return flag
    },
    flagss (fla) {
      if (fla == false) {
        this.fla = true
      } else {
        this.fla = false
      }
      return fla
    }

  }
}
</script>

<style lang="less" scoped>
footer{
    width: 100%;
    position: relative;
    .across{
        display: flex;
     .col-firt{
         margin-right: 12%;
      }
    }
    .lh{
        height: 12px !important;
    }
    .ll{
        margin-top: 10px !important;
    }
    .move{
        display: none;
    }
    .web{
        display: block;
    }
    .right{
        padding-left: 22%;
    }
}
// @media screen and(max-width:475px) {
//   .foot-container{
//     width: 100%;
//   }
// }
footer .foot-container{
    width:100%;
    background-color: #183553;
}
footer .contact-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 12%;
    padding-right: 12%;
    padding-top: 2%;
}
footer .contact-top dt{
    color: #fff;
    padding-top: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    width: 120px;
    a{
        color: #fff
    }
}
footer .contact-top dl{
    display: inline;
}

footer .wx{
    img{
    width: 100px;
    height: 100px;
    }
    dd{
        text-align: center;
        width: 100px;
        a{
            color: #fff;
        }
    }
}
footer .contact-top dd {
    color: #fff;
    height: 20px;
    line-height: 20px;
    font-size: 9px;
    margin: 0;
    cursor: pointer;
   a{
            color: #fff;
        }
}
footer .contact-bot {
    margin-top: 20px;
    color: #D6DADF;
    font-size: 12px;
    // overflow: hidden;
    position: relative;
    height: 90px;
    a{
        width: 25%;
        height: 40px;
        position: absolute;
        bottom: 40px;
        right: 0;
        .erweima{
            display: none;
            width: 60px !important;
            height: 60px !important;
            position: absolute;
            top: -30px;
            left: -70px;
            background-color: #fff;
        }
    }
    a:hover{
        .erweima{
            display: block
        }
    }
}
footer .contact-bot .left{
    width: 100%;
    font-size: 8px;
    text-align: center;
    bottom: 20%;
    p{
        width: 100%;
        cursor: pointer;
    }
}
footer .contact-bot .right{
    float: right;
    padding-right: 5%;
}
footer .contact-bot .right a{
    display: block;
    float: right ;
    margin-right: 12px;
    width: 16px;
    height: 16px;
}
footer .contact-bot .right img {
    width: 100%;
    height: 100%;
}
@media screen and(max-width: 750px){
    footer{
        dt{
            font-size: 18px !important;
            width: 100% !important;
            border-bottom: 1px solid #3A4E66;
        }
        .right{
            padding-left: 0;
            dt{
            }
        }
    }
    .wechat{
        height: 25px;
        vertical-align:text-top;
        margin-left: 15px;
    }
    footer .contact-top{
        margin-top: 20px;
    }
    footer .wx .center{
        width: 100% !important;
        text-align: center !important;
        font-size: 18px;
        border: none !important;
    }
    footer dt{
        line-height: 60px;
    }
    footer .contact-top dt{
        padding: 0;
        margin: 0;
    }
    footer .contact-top dt a{
        display: block;
        width: 100%;
    }
        footer .contact-top dd{
            height: 50px;
        }
    footer .contact-top dd a{
        opacity: .5;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        display: block;
        width: 100%;
    }
    footer .contact-top{
        display: block !important;
    }
    footer .across{
        display: block;
        width: 113%;
    }
    footer .lh{
        height: 25px !important;
    }
     .move{
        display: block !important;
        span{
            float: right;
        }
        .down{
            transition: all .3s;
            transform:rotate(0deg);
          }
          .up{
           transition: all .3s;
           transform:rotate(135deg);
          }
    }
    .center{
        img{
            padding-top: 40px;
        }
    }
    .web{
        display: none !important;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/hpComponents/footer.vue